@if (this.editLockService.klantNo() != undefined) {
    @let _isLocked = this.isLocked();
    @let _hasLock = this.hasLock();
        @if (_hasLock) {
        <button kendoButton [svgIcon]="this.lockIcon" [style]="{width: '140px'}" (click)="this.unlock()">{{'Deblokkeren' | translate: 'Deblokkeren'}}</button>
    } @else {
        @if (_isLocked) {
            <span class="in-use">{{'In gebruik door: ' | translate: 'In gebruik door:'}}{{this.editLockService.lockInfo()?.editLock?.user}}</span>
        } @else {
            <button kendoButton [svgIcon]="this.unlockIcon" [style]="{width: '125px'}" (click)="this.lock()">{{'Blokkeren' | translate: 'Blokkeren'}}</button>
        }
    }
        
}
